import $ from "jquery";
import React, { Component } from "react";
import { formValueSelector, Fields, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import Loading from "../../../components/Loading";

import ImageResolver from "containers/ImageResolver";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import { addPreviousPreviews } from "./../../../actions";
import SeparatingLine from "../../../components/SeparatingLine";
import { getAllDoorColours } from "./../../../selectors";
import FormWrapper from "../../FormWrapper";
import FormHeader from "../../../components/FormHeader";
import HandleSelector from '../../../components/HandleSelector';
import utils from '../../../utils';
import { updatePreviousSelection } from '../../../actions';
import ExtraSwitchField from "../../../components/ExtraSwitchField";


const SelectHandle = props => {
    let { handles, DoorHandleType, DoorHandleId, selectedColour, addPreviousPreviews, useAltBestMatch, previousSelection, hideHandleType } = props;

    if ($.isEmptyObject(handles)) {
        return <Loading />;
    }

    return (
        <div>
            <Row isColumn>
                <h4>Handle</h4>
            </Row>

            <HandleSelector
                hideHandleType={hideHandleType}
                handles={handles}
                HandleType={DoorHandleType}
                HandleId={DoorHandleId}
                selectedColour={selectedColour}
                useAltBestMatch={useAltBestMatch}
                addPreviousPreviews={addPreviousPreviews}
                previousSelectionHandleColour={previousSelection.DoorPvcHandleColour} />

            <InputError metas={[DoorHandleType.meta, DoorHandleId.meta]} />
        </div>
    );
};

class HandleForm extends Component {

    constructor() {
        super();
        this.state = {
            loaded: false
        };
    }

    componentDidUpdate() {
        let {
            selectedHandle,
            selectedType,
            handles,
            selectedColour,
            dispatch,
            addPreviousPreviews,
            previousSelection
        } = this.props;

        if (!selectedHandle.id && this.state.loaded === false) {
            if (handles.length > 0) {

                var handleId = utils.getExtraBestMatch(handles, selectedColour, selectedType.useAltBestMatch);

                var previousHandleId = utils.findHandleByColour(handles, previousSelection.DoorPvcHandleColour, previousSelection.DoorPvcHandleType);

                handleId = previousHandleId || handleId;

                // default handle
                dispatch(change("DoorWizard", "DoorHandleId", handleId));
                addPreviousPreviews({ colourId: selectedColour.id, extraId: handleId }, [1, 3]);

                // check if there's only 1 type
                const handleTypes = handles
                    .map(handle => ({
                        name: handle.description2,
                        imageUrl: handle.externalImageUrl2
                    }))
                    .filter(
                        (type, index, types) =>
                            types.map(h => h.name).indexOf(type.name) === index
                    );

                if(handleTypes.length === 1){
                    dispatch(change("DoorWizard", "DoorHandleType", handleTypes[0].name));
                }

                if (previousSelection.DoorPvcLock)
                    dispatch(change("DoorWizard", "DoorAtkLockatDoorAtkLockat", previousSelection.DoorPvcLock));

                this.setState({ loaded: true });
            }
        }
    }

    onSubmit(values) {

        var handle = utils.getValueById(this.props.handles, values.DoorHandleId);

        this.props.updatePreviousSelection({
            DoorPvcHandleColour: handle.description1,
            DoorPvcHandleType: handle.description2,
            DoorPvcLock: values.DoorAtkLock
        });

        this.props.onSubmit(values);
    }


    onLockChange(e) {
        let value = e.target.checked;

        const { upgradeExtra, upgradableExtra } = this.props;

        if (!value) {
            this.props.addPreviousPreviews({ extraGroupId: upgradableExtra.extraGroupId, extraId: upgradableExtra.id }, [4]);
        }
        else {
            this.props.addPreviousPreviews({ extraGroupId: upgradeExtra.extraGroupId, extraId: upgradeExtra.id }, [4]);
        }
    }

    render() {
        const {
            upgradeExtra,
            handleSubmit,
            doorTypeId,
            selectedColour,
            doorHandleId,
            selectedHandle,
            handles,
            isFrenchDoor,
            selectedType,
            addPreviousPreviews,
            previousSelection
        } = this.props;

        const handleTypeCount = [
            ...new Set(this.props.handles.map(handle => handle.description2))
        ].length;

        return (
            <form
                className="HandleForm uPVC"
                onSubmit={handleSubmit(this.onSubmit.bind(this))}
            >
                <FormHeader
                    title={"Handles & locks"}
                    subtitle={"We can supply a wide range of finish colours and textures"}
                />

                <SeparatingLine />
                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={7} large={5} className="preview-container">
                            <ImageResolver
                                query={{ productId: doorTypeId }}
                                filters={{
                                    colourId: selectedColour.id,
                                    extraId: doorHandleId
                                }}
                            />
                        </Column>
                        <Column className="colour-name-container" showOnlyFor="small">
                            {selectedHandle.name}
                        </Column>
                        <Column
                            className={"swatch-selector-container"}
                            pullOnLarge={6}
                            large={6}
                            style={{ paddingTop: 10 }}
                        >
                            <Row>
                                <Column small={12}>
                                    <Fields
                                        names={["DoorHandleType", "DoorHandleId"]}
                                        component={SelectHandle}
                                        hideHandleType={handleTypeCount === 1}
                                        handles={handles}
                                        isFrenchDoor={isFrenchDoor}
                                        selectedColour={selectedColour}
                                        useAltBestMatch={selectedType.useAltBestMatch}
                                        addPreviousPreviews={val =>
                                            addPreviousPreviews(
                                                {
                                                    colourId: selectedColour.id,
                                                    extraId: val
                                                },
                                                [1, 3]
                                            )
                                        }
                                        onTypeChange={type =>
                                            type === null
                                                ? addPreviousPreviews(
                                                    { extraGroupId: 40, extraId: 147 },
                                                    [4]
                                                )
                                                : null
                                        }
                                        previousSelection={previousSelection}
                                    />
                                </Column>
                            </Row>
                            {upgradeExtra && (
                                <ExtraSwitchField upgradeExtra={upgradeExtra} fieldName="DoorAtkLock" onChange={this.onLockChange.bind(this)} />
                            )}
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button
                        className="button back"
                        type="button"
                        onClick={this.props.previousPage}
                    >
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorTypeId = valueSelector(state, "DoorTypeId") || 7;
    let doorColourId = valueSelector(state, "DoorColourId");
    let doorHandleId = valueSelector(state, "DoorHandleId");
    let doorHandleType = valueSelector(state, "DoorHandleType");
    let doorColourInterior = valueSelector(state, "DoorColourInterior");

    let extras = state.Door.Options.extras;
    extras.sort(utils.sortExtraByRank);
    let colours = getAllDoorColours(state);

    let handles = [];

    const upgradableExtra = extras.find(extra => extra.upgradeExtraId);
    const upgradeExtra = extras.find(extra => extra.isUpgrade);

    if (upgradableExtra && (!upgradeExtra || upgradeExtra.id !== upgradableExtra.upgradeExtraId)) {
        console.error(
            `There was an error finding the extra upgrade. Found Upgradable extra id=${
                upgradableExtra.id
            } with upgradeExtraId=${upgradableExtra.upgradeExtraId} but no matching extra`
        );
    }

    for (var extra in extras) {
        if (/handle/i.test(extras[extra].extraGroupName)) handles.push(extras[extra]);
    }

    let selectedType = state.Door.Types.filter(c => c.id === doorTypeId)[0] || {};

    let selectedHandle = handles.filter(c => c.id === doorHandleId)[0] || {};

    let selectedColour = colours.filter(c => c.id === doorColourId)[0];
    if (doorColourInterior && selectedColour.relatedColourId) {
        selectedColour = colours.filter(c => c.id === selectedColour.relatedColourId)[0];
    }

    return {
        handles,
        doorTypeId,
        selectedColour,
        doorHandleId,
        selectedHandle,
        doorHandleType,
        selectedType,
        previousSelection: state.PreviousSelection,
        upgradableExtra,
        upgradeExtra
    };
};

export default connect(mapStateToProps, { addPreviousPreviews, updatePreviousSelection })(HandleForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/HandleForm.js